import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type BroadcastRecorder from "./BroadcastRecorder";
import type TvChannel from "./TvChannel";

@Model()
class TvChannelsBroadcastRecorder extends ApplicationRecord {
  static jsonapiType = "tv_channels_broadcast_recorders";

  @BelongsTo() broadcastRecorder: BroadcastRecorder;

  @Attr() primary: boolean;

  @BelongsTo() tvChannel: TvChannel;

  @Attr() tvChannelId: number;
}

export default TvChannelsBroadcastRecorder;
